import { render, staticRenderFns } from "./FaturasBoletos.old.vue?vue&type=template&id=cedd53e6&scoped=true"
import script from "./FaturasBoletos.old.vue?vue&type=script&lang=js"
export * from "./FaturasBoletos.old.vue?vue&type=script&lang=js"
import style0 from "./FaturasBoletos.old.vue?vue&type=style&index=0&id=cedd53e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedd53e6",
  null
  
)

export default component.exports